// src/services/authService.ts

import { User } from "../models/User";
import apiClient from "./apiClient";

const API_URL = process.env.REACT_APP_API_URL || "";

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
  // user: {
  //   adminID: number;
  //   email: string;
  //   firstName: string;
  //   lastName: string;
  // };
}

export async function login(
  email: string,
  password: string
): Promise<LoginResponse> {
  try {
    const response = await apiClient.post<LoginResponse>("/auth/login", {
      email,
      password,
    });
    return response.data;

    if (!response) {
      throw new Error("Login failed");
    }

    return response.data; // Return the response data
  } catch (error) {
    console.error("Failed to login user:", error);
    throw new Error("Failed to login user");
  }
}
export async function refreshToken(): Promise<string> {
  try {
    const response = await apiClient.post<{ token: string }>(
      "/auth/refreshToken"
    );
    return response.data.token;
  } catch (error) {
    console.error("Failed to refresh token:", error);
    throw new Error("Failed to refresh token");
  }
}

export const logout = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  const userId = localStorage.getItem("userId"); // Assuming you store the user ID
  try {
    await apiClient.post("/auth/logout", { userId, refreshToken });
  } catch (error) {
    console.error("Logout failed", error);
  } finally {
    // Clear tokens from local storage regardless of server response
    // localStorage.removeItem('accessToken');
    // localStorage.removeItem('refreshToken');
    // localStorage.removeItem('userId');
  }
};
